import type { JSX } from 'preact';
import type { Product } from '@/domain/Product';
import SkeletonText from '@/widgets/components/controls/Skeleton/SkeletonText';
import styles from './ProductNameSection.module.scss';
import FavoriteButton from '@/widgets/ProductList/cards/sections/FavoriteButton/FavoriteButton';

export type ProductNameSectionProps = {
  product: Product;
  itemListName: string;
} & JSX.HTMLAttributes<HTMLElement>;

export default function ProductNameSection({
  product,
  itemListName,
  ...rest
}: ProductNameSectionProps) {
  return (
    <section class={styles.container} {...rest}>
      <h1 class={styles.heading}>{product.name}</h1>
      <FavoriteButton
        class={styles.favoriteButton}
        product={product}
        itemListName={itemListName}
      />
    </section>
  );
}

ProductNameSection.Skeleton = function Skeleton({
  ...rest
}: JSX.HTMLAttributes<HTMLElement>) {
  return (
    <section {...rest}>
      <h1 class={styles.heading}>
        <SkeletonText />
      </h1>
    </section>
  );
};
